<template>
  <div id="column">
    <div class="listHead">
      <div>
        <div class="sCircle" />
        <span style="font-size:16px;font-weight:700">优学派官方平台-产品介绍-栏目维护</span>
      </div>
      <div>
        <el-button
          type="primary"
          size="small"
          @click="addItem()"
        >
          添加
        </el-button>
      </div>
    </div>
    <el-tree
      ref="tree"
      class="column-tree"
      :data="treeList"
      :props="defaultProps"
      :highlight-current="true"
      node-key="catalogId"
      :current-node-key="currentNode"
      :default-expand-all="true"
      @node-click="handleNodeClick"
    >
      <span
        slot-scope="{ node, data }"
        class="custom-tree-node"
      >
        <span style="margin-right:5px">{{ data[defaultProps.label] }}</span>
        <mix-tooltip
          v-if="data.status !== 1"
          :enterable="false"
          content="已禁用"
          popper-class="user-table-tooltip weight"
          placement="top"
          effect="light"
        >
          <i
            class="el-icon-info"
          />
        </mix-tooltip>
        <span class="icon-wrap">
          <mix-tooltip
            :enterable="false"
            content="查看详情"
            popper-class="user-table-tooltip weight"
            placement="top"
            effect="light"
          >
            <i
              class="icon_detail"
              @click.stop="editNode(node, data, 'emit')"
            />
          </mix-tooltip>
          <mix-tooltip
            v-if="data.type === 0 && data.catalogLevel < siteLevel"
            :enterable="false"
            content="添加下级栏目"
            popper-class="user-table-tooltip weight"
            placement="top"
            effect="light"
          >
            <i
              class="icon_add"
              @click.stop="addChildNode(node, data, 'emit')"
            />
          </mix-tooltip>
          <mix-tooltip
            v-if="data.status == 1"
            :enterable="false"
            content="禁用"
            popper-class="user-table-tooltip weight"
            placement="top"
            effect="light"
          >
            <i
              class="icon_disable"
              @click.stop="changeNodeStatus(node, data)"
            />
          </mix-tooltip>
          <mix-tooltip
            v-else
            :enterable="false"
            content="启用"
            popper-class="user-table-tooltip weight"
            placement="top"
            effect="light"
          >
            <i
              class="icon_enable"
              @click.stop="changeNodeStatus(node, data)"
            />
          </mix-tooltip>
          <mix-tooltip
            :enterable="false"
            content="上移"
            popper-class="user-table-tooltip weight"
            placement="top"
            effect="light"
          >
            <i
              v-if="showBtn(node, data, 'up')"
              class="icon_up"
              @click.stop="nodeUp(node, data, 'emit')"
            />
          </mix-tooltip>
          <mix-tooltip
            :enterable="false"
            content="下移"
            popper-class="user-table-tooltip weight"
            placement="top"
            effect="light"
          >
            <i
              v-if="showBtn(node, data, 'down')"
              class="icon_down"
              @click.stop="nodeDown(node, data, 'emit')"
            />
          </mix-tooltip>
        </span>
      </span>
    </el-tree>
    <div class="footer">
      <el-button
        type="primary"
        size="small"
        @click="$router.push({ name: 'contentManage', query: { ...$route.query, stack: Number($route.query.stack - 1) }})"
      >
        返回内容管理
      </el-button>
    </div>
    <mix-dialog
      :modal="true"
      width="520px"
      class="right-dialog column-dialog"
      :append-to-body="true"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @click.native="cancel"
    >
      <div
        class="dialog-container"
        @click.stop
      >
        <div
          slot="title"
          class="dialog-title"
        >
          <span>添加栏目</span>
          <i
            class="el-icon-close"
            @click="cancel"
          />
        </div>
        <div v-if="column">
          <el-form
            ref="ruleForm"
            :model="column"
            :rules="rules"
            label-position="right"
            label-width="100px"
          >
            <el-form-item
              label="栏目类型"
              prop="type"
            >
              <el-radio-group v-model="column.type">
                <el-radio :label="0">
                  内容栏目
                </el-radio>
                <el-radio :label="1">
                  链接栏目
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="父级栏目"
              prop="pCatalogId"
            >
              <div
                class="pCatalogName"
                :class="lock ? 'locked' : ''"
                @click="showTreeVisible"
              >
                {{ parentName || '请选择父级栏目' }}
              </div>
            </el-form-item>
            <el-form-item
              label="栏目名称"
              prop="name"
            >
              <el-input
                v-model.trim="column.name"
                :maxlength="12"
                placeholder="请输入栏目名称"
              />
            </el-form-item>
            <el-form-item
              label="栏目缩略图"
              prop="image"
            >
              <div class="image-wrapper">
                <div class="image-operation">
                  <yxp-upload
                    v-if="!column.image"
                    ref="yxpupload"
                    uploader-id="uploadId"
                    :limit="1"
                    :max-size="500"
                    :accept="acceptType"
                    :file-list="list"
                    upload-url="/res-file/upload/"
                    upload-mode-type="resource/wangyeguanli"
                    btn-name=""
                    class-name="cover-button"
                    :show-list="false"
                    :auto-upload="true"
                    @onChange="onChange"
                    @onFail="onFail"
                    @onSucc="onSucc"
                  />
                  <template v-else>
                    <img
                      :src="column.image"
                      @click="previewDialog=true"
                    >
                    <i
                      class="el-icon-error"
                      @click="column.image = null"
                    />
                  </template>
                </div>
              </div>
              <div class="tip">
                建议栏目缩略图大小300KB
              </div>
            </el-form-item>
            <el-form-item
              v-if="column.type === 1"
              label="栏目链接"
              prop="catalogLink"
            >
              <el-input
                v-model.trim="column.catalogLink"
                placeholder="请输入栏目链接地址，以http或https开头"
              />
            </el-form-item>
            <el-form-item
              label="栏目描述"
              prop="description"
            >
              <el-input
                v-model="column.description"
                class="textarea"
                type="textarea"
                :maxlength="20"
                placeholder="请输入栏目描述"
                show-word-limit
                :autosize="true"
                resize="none"
              />
            </el-form-item>
          </el-form>
          <div class="dialog-footer">
            <el-button
              v-if="column.catalogId"
              size="medium"
              class="btn-plain disable-button"
              @click="changeNodeStatus(null, column)"
            >
              {{ column.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button
              size="medium"
              class="btn-plain cancel-button"
              @click="cancel"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              :loading="loading"
              @click="submitForm"
            >
              确认
            </el-button>
          </div>
        </div>
      </div>
      <el-dialog
        class="column-dia"
        :visible.sync="showTreeDialog"
        :append-to-body="true"
        width="500px"
      >
        <div
          slot="title"
          class="dialog-title"
        >
          <span>所属栏目</span>
        </div>
        <div
          class="min-scrollbar"
          style="max-height: 400px; overflow-y: auto; border: 1px solid #DCDFE6;"
        >
          <el-tree
            class="column-tree"
            :data="parentList"
            node-key="catalogId"
            :props="defaultProps"
            :expand-on-click-node="false"
            :highlight-current="true"
            :default-expanded-keys="defaultExpandedKeys"
            @node-click="handleClick"
          />
        </div>
        <div class="tree-dialog-footer">
          <el-button @click="showTreeDialog = false">
            取消
          </el-button>
          <el-button
            type="primary"
            @click="confirm"
          >
            确定
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        v-if="previewDialog"
        :visible.sync="previewDialog"
        width="50%"
        :append-to-body="true"
      >
        <div
          slot="title"
          class="dialog-title"
        >
          <span>预览图片</span>
        </div>
        <div style="text-align: center; display: flex; justify-content: center; align-items: center; min-height: 300px;">
          <img
            :src="column.image"
            style="max-width: 100%; max-height: 600px;"
          >
        </div>
      </el-dialog>
    </mix-dialog>
  </div>
</template>

<script>
import api from './proxy';
import UploadImg from '../../../common/tools/UploadImg';

export default {
    name: 'Column',
    components: { UploadImg },
    data () {
        var checkLink = (rule, value, callback) => {
            if (!value) return callback(new Error('栏目链接不能为空'));
            let strRegex = '^((https|http|ftp|rtsp|mms)?://)' +
                "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" + // ftp的user@
                '(([0-9]{1,3}\.){3}[0-9]{1,3}' + // IP形式的URL- 199.194.52.184
                '|' + // 允许IP和DOMAIN（域名）
                "([0-9a-z_!~*'()-]+\.)*" + // 域名- www.
                '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.' + // 二级域名
                '[a-z]{2,6})' + // first level domain- .com or .museum
                '(:[0-9]{1,4})?' + // 端口- :80
                // '((/?)|' + // a slash isn't required if there is no file name
                // "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
                '';
            let re = new RegExp(strRegex);
            if (re.test(value)) {
                callback();
            } else {
                return callback(new Error('栏目链接格式错误'));
            }
        };
        return {
            treeList: [],
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            currentNode: null,
            showDialog: false,
            showTreeDialog: false,
            column: null,
            siteLevel: 9,
            parentName: '',
            rules: {
                type: [{ required: true, message: '请选择栏目类型', trigger: 'change' }],
                pCatalogId: [{ required: true, message: '请选择父级栏目', trigger: 'change' }],
                name: [{ required: true, message: '请选择输入栏目名称', trigger: [ 'change', 'blur' ] }],
                // image: [{ required: true, message: '请上传栏目缩略图', trigger: 'change' }],
                catalogLink: [{ required: true, validator: checkLink, trigger: 'blur' }],
            },
            parentList: [],
            loading: false,
            lock: false,
            acceptType: '.jpg,.jpeg,.png',
            list: [],
            selectNode: null,
            defaultExpandedKeys: [],
            previewDialog: false,
        };
    },
    computed: {
        cpUserId () {
            return this.$store.state.global.loginInfo.userId;
        },
        siteId () {
            return this.$route.query.siteId || (this.$store.getters['system/getSiteList'].length > 0 ? this.$store.getters['system/getSiteList'][0].siteId : null);
        },
    },
    created () {
        if (!this.siteId) return this.$router.replace({ name: 'pageDetail', query: { client: 'back' } });
        this.getTreeList();
    },
    methods: {
        getTreeList () {
            api.getTreeList({ siteId: this.siteId, isShowDisable: 1 }).then(res => {
                if (res.errcode === 0) {
                    this.treeList = res.data.value.catalogList;
                    this.siteLevel = res.data.value.siteLevel;
                }
            });
        },
        handleNodeClick (node) {
            if (node.children.length === 0) console.log(node.name);
        },
        handleClick (node) {
            this.selectNode = node;
        },
        confirm () {
            if (!this.selectNode) return;
            if (this.selectNode.catalogLevel < this.siteLevel) {
                this.column.pCatalogId = this.selectNode.catalogId;
                this.column.pCatalogLevel = this.selectNode.catalogLevel;
                this.column.catalogLevel = this.selectNode.catalogLevel + 1;
                this.showTreeDialog = false;
                this.parentName = this.selectNode.name;
            } else {
                this.$message.warning('栏目最大层级为' + this.siteLevel + '级');
            }
        },
        showBtn (node, data, ty) {
            let parent = node.parent,
                children = parent.data.children || parent.data,
                idx = children.findIndex(itm => itm === data);
            return ty === 'up' ? idx !== 0 : idx !== children.length - 1;
        },
        changeNodeStatus (node, data) {
            this.$confirm(data.status == 0 ? '确认是否启用目录?' : '禁用目录后，该目录及其子级栏目都将被禁用。被禁用的目录下的内容将无法再进行访问，请谨慎操作。确认禁用？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                api.changeStatus({ catalogId: data.catalogId, status: data.status == 0 ? 1 : 0 }).then(res => {
                    if (res.errcode === 0) {
                        data.status = data.status == 0 ? 1 : 0;
                        this.getTreeList();
                    }
                });
            }).catch(() => {
            });
        },
        editNode (node, data) {
            api.getColumnInfo({ catalogId: data.catalogId }).then(res => {
                if (res.errcode === 0) {
                    this.addItem(res.data.value);
                    if (res.data.value.pCatalogId) {
                        let name = this.getParentName(this.treeList, res.data.value.pCatalogId);
                    } else {
                        this.parentName = '站点栏目';
                    }
                } else {
                    this.$message.warning(res.errmsg);
                }
            });
        },
        getParentName (list, catalogId, parentName) {
            if (parentName) return;
            list.forEach(item => {
                if (item.catalogId === catalogId) {
                    this.parentName = item.name;
                }
                if (item.children.length > 0 && !parentName) this.getParentName(item.children, catalogId, parentName);
            });
        },
        // 添加下级栏目
        addChildNode (node, data) {
            this.lock = true;
            this.addItem({
                catalogId: null,
                name: '',
                type: 0,
                image: '',
                description: '',
                catalogLink: '',
                pCatalogId: data.catalogId,
                pCatalogLevel: data.catalogLevel,
            });
            this.parentName = data.name;
        },
        nodeUp (node, data, type = 'handler') {
            if (type === 'handler') {
                let parent = node.parent,
                    children = parent.data.children || parent.data,
                    idx = children.findIndex(itm => itm === data),
                    prevData = children[idx - 1];

                this.$refs.tree.remove(prevData);
                this.$refs.tree.insertAfter(prevData, node);
            } else {
                this.rankNode(-1, { node, data });
            }
        },
        nodeDown (node, data, type = 'handler') {
            if (type === 'handler') {
                let parent = node.parent,
                    children = parent.data.children || parent.data,
                    idx = children.findIndex(itm => itm === data),
                    behind = children[idx + 1];
                children.splice(idx, 2, children[idx + 1], children[idx]);
                this.$refs.tree.remove(behind);
                this.$refs.tree.insertBefore(behind, node);
            } else {
                this.rankNode(1, { node, data });
            }
        },
        /* 目录排序 */
        rankNode (operation, { node, data }) {
            let parent = node.parent,
                children = parent.data.children || parent.data,
                idx = children.findIndex(itm => itm === data);
            if (operation === -1 && idx === 0) {
                this.$message.warning('不能继续上移');
                return;
            }
            if (operation === 1 && idx === children.length - 1) {
                this.$message.warning('不能继续下移');
                return;
            }
            api.move({
                move: operation,
                catalogId: data.catalogId,
            }).then(res => {
                if (res.errcode === 0) {
                    // this.getTreeList();
                    if (operation === 1) {
                        this.nodeDown(node, data, 'handler');
                    } else {
                        this.nodeUp(node, data, 'handler');
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        getparentList (catalogId) {
            api.getTreeList({ siteId: this.siteId, catalogId, isShowDisable: 1 }).then(res => {
                if (res.errcode === 0) {
                    const all = {
                        catalogId: 0,
                        catalogLevel: 0,
                        pCatalogId: null,
                        name: '站点栏目',
                        type: '0',
                        image: '',
                        describe: '',
                        catalogLink: '',
                        rank: 0,
                        status: 0,
                        children: [],
                    };
                    all.children = res.data.value.catalogList;
                    this.defaultExpandedKeys = [0];
                    res.data.value.catalogList.forEach(item => {
                        this.defaultExpandedKeys.push(item.catalogId);
                        if (item.children.length > 0) {
                            item.children.forEach(it => {
                                this.defaultExpandedKeys.push(item.catalogId);
                            });
                        }
                    });
                    console.log('defaultExpandedKeys', this.defaultExpandedKeys);
                    this.parentList = [all];
                }
            });
        },
        showTreeVisible () {
            if (this.lock) return;
            this.showTreeDialog = true;
        },
        addItem (data) {
            if (!this.lock) this.getparentList(data ? data.catalogId : null);
            if (data) {
                this.column = { ...data };
            } else {
                this.column = {
                    catalogId: null,
                    name: '',
                    type: 0,
                    pCatalogId: null,
                    pCatalogLevel: null,
                    image: '',
                    description: '',
                    catalogLink: '',
                };
                this.parentName = '';
            }
            this.showDialog = true;
            window.addEventListener('keydown', this.keydownHandler);
        },
        onSucc (res, file) {
            console.log(res.url);
            if (this.column) {
                this.column.image = res.url;
                this.list = [];
            }
        },
        onChange (file) {
            // console.log(file);
        },
        onFail (file) {
            // console.log(file);
            this.$message.warning(file.errMsg);
        },
        // uploadSuccess (p) {
        //     this.column.image = p.fileUrl;
        // },
        handleExceedLimit () {
            this.$message.error('图片数量已超出，只允许上传1张！');
        },
        keydownHandler (key) {
            if (key.keyCode === 27) this.cancel();
        },
        cancel () {
            if (this.column.pCatalogId || this.column.name || this.column.image || this.column.description || (this.column.type === 1 && this.column.catalogLink)) {
                this.$confirm('关闭后数据不保存，确认退出？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.showDialog = false;
                    this.column = null;
                    this.lock = false;
                    this.parentName = '';
                    window.removeEventListener('keydown', this.keydownHandler);
                }).catch(() => {
                });
            } else {
                this.showDialog = false;
                this.column = null;
                this.lock = false;
                this.parentName = '';
                window.removeEventListener('keydown', this.keydownHandler);
            }
        },
        submitForm () {
            // 删除零宽空格转义字符
            this.column.name = this.column.name.replace(/\u200B/g, '');
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    console.log(1111, this.column);
                    const params = {
                        ...this.column,
                        siteId: this.siteId,
                    };
                    api.save(params).then(res => {
                        if (res.errcode === 0) {
                            this.$message.success('保存成功');
                            this.showDialog = false;
                            this.getTreeList();
                        } else {
                            this.$message.warning(res.errmsg);
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss">
#column {
    .listHead {
        padding-left: 24px;
        padding-right: 24px;
        width: 100%;
        height: 53px;
        line-height: 53px;
        background-color: #fff;
        margin-top: 10px;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .sCircle {
        margin-bottom: 2px;
        margin-right: 10px;
        display: inline-block;
        border: 2px solid #ccc;
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }
    .plainBtn {
        border-color: #2ED095 !important;
        color: #2ED095;
    }
    .el-tree {
        width: 100%;
        overflow-y: auto;
        .icon-wrap {
            display: none;
            margin-left: 15px;
            .icon_detail {
                padding: 0 15px;
                background: url("../../../../assets/icon/icon_detail.png") no-repeat center;
                background-size: 17px 17px;
            }
            .icon_add {
                padding: 0 15px;
                background: url("../../../../assets/icon/icon_add.png") no-repeat center;
                background-size: 17px 17px;
            }
            .icon_disable {
                padding: 0 15px;
                background: url("../../../../assets/icon/icon_disable.png") no-repeat center;
                background-size: 17px 17px;
            }
            .icon_enable {
                padding: 0 15px;
                background: url("../../../../assets/icon/icon_enable.png") no-repeat center;
                background-size: 17px 17px;
            }
            .icon_up {
                padding: 0 15px;
                background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAQJJREFUOBFj/P//P6PB5RkFDP/+Zf1nYFBhIAQYGf8z/v9/l4GJadoF3YwJjPqXphf+//evj5A+bPKMTExFTCCbsUkSJQbUy4TP2UlihgyFkpY4zfrPyKjMgks2XtSAIR+q+c//fwyTX5zEVAoMPyZMUQaGaBE9hiIpK7hUirgxQ5a4GZyPzMAwIEJYh6FM2gZZDZidLmHCkC5ugiGO4YWdH+4w7Pp4F6xwv3YimHa8Oh9DI0wAw4D3f3/A5OD0uz/f4Wx0BoYX0BUQ4g8GA4Bpm5AzccqD8oX+ham38aVGnJqBEowMDHeYQLkKnyK8ckC9wJyJlJ2BaZsByMerCS07AwAKNVJQxx4D6AAAAABJRU5ErkJggg==") no-repeat center;
            }
            .icon_down {
                padding: 0 15px;
                background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAR9JREFUOBFj/P//P6PB5RkFDP/+Zf1nYFBhIAQYGf8z/v9/l4GJadoF3YwJjPqXphf+//evj5A+bPKMTExFTCCbsUmCxJgYGBmYgRgnAOplwufsA9qJDOf0Mxn4mNmxmvGfkVGZCasMsYLA8KPMAKBFA28AC7p3RVi44OHOyAiJAVGgGDsjM1jp6z/fULRgGODIr8hQI2OPomidRiSYP+n5CYa5r86hyGGEweq3VxnanxxCUQTiTHtxCkMzSBzDAJDgirdXGLqeHgExwWDmizMMM1+egXFRaBYGYNpmAMYniiiQs/TNJQYWYCyDEtG0l6fQpSF8oF4WUMbAlRoXvr6AXSNUFKSXCZSr8KrCJwnUCzQEKTsD0zY276CYgZadATZsYfHGogElAAAAAElFTkSuQmCC") no-repeat center;
            }
        }
        .el-tree-node__content {
            height: 36px;
            &:hover {
                .icon-wrap {
                    display: inline;
                }
            }
        }
        .custom-tree-node {
            user-select: none;
        }
    }
    .footer {
        line-height: 64px;
        text-align: center;
        background: #FFF;
    }
}
</style>
<style lang="scss">
.min-scrollbar {
    &:hover {
        &::-webkit-scrollbar-thumb {
            opacity: 0;
        }
    }
    &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    &::-webkit-scrollbar-thumb {
        opacity: 0;
        border-radius: 4px;
        background-color: #E0E3EA;
    }
}
.column-dialog {
    .el-dialog__header {
        display: none;
    }
    .dialog-title {
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 0;
        line-height: 52px;
        background: #FFF;
        .el-icon-close {
            font-size: 20px;
            cursor: pointer;
        }
    }
    .dialog-container {
        height: calc(100vh - 60px);
        .el-form {
            margin-top: 20px;
            padding: 0 24px;
            .el-form-item {
                .pCatalogName {
                    padding: 0 10px;
                    width: 360px;
                    border: 1px solid #DBDEE5;
                    border-radius: 4px;
                    background: #F2F4FC;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    cursor: pointer;
                    &.locked {
                        color: #606266;
                        cursor: not-allowed;
                    }
                }
                .el-form-item__label {
                    color: #1E1E1E;
                }
                .el-select {
                    width: 100% !important;
                }
                .image-wrapper {
                    display: flex;
                    .default {
                        width: 124px;
                        height: 80px;
                        background: #F2F4FC;
                    }
                    .image-operation {
                        position: relative;
                        margin-top: 15px;
                        margin-right: 15px;
                        display: inline-block;
                        vertical-align: top;
                        width: 124px;
                        height: 80px;
                        background: #F2F4FC;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .cover-button {
                            width: 124px;
                            height: 80px;
                            border-radius: 4px;
                            background: url('../../../../assets/icon/icon_plus.png') no-repeat center;
                            background-color: #F2F4FC;
                            background-size: 20px 20px;
                            &:hover {
                                background-color: #F2EEFC;
                            }
                        }
                        img {
                            max-width: 100%;
                            max-height: 100%;
                            border-radius: 4px;
                            cursor: pointer;
                        }
                        i {
                            position: absolute;
                            top: -8px;
                            right: -8px;
                            z-index: 1;
                            font-size: 18px;
                            color: #999;
                            cursor: pointer;
                        }
                    }
                }
                .tip {
                    margin-top: 14px;
                    line-height: 14px;
                    color: #F3864B;
                }
                .textarea {
                    textarea {
                        @extend .min-scrollbar;
                        height: 56px !important;
                    }
                    .el-input__count {
                        // bottom: 0;
                        font-size: 14px;
                        line-height: 14px;
                        color: #DBDEE5;
                    }
                }
            }
        }
        .dialog-footer {
            position: absolute;
            bottom: 0;
            width: 100%;
            line-height: 64px;
            text-align: center;
            background: #FFF;
            .el-button {
                margin-right: 10px;
                width: 100px;
                &.disable-button {
                    color: #F3864B;
                    border-color: #F3864B;
                }
                &.cancel-button {
                    color: #2FCF94;
                    border-color: #2FCF94;
                }
            }
        }
    }
}
.column-dia {
    .tree-dialog-footer {
        margin-top: 15px;
        line-height: 50px;
        text-align: right;
        .el-button {
            margin-left: 15px;
            width: 80px;
        }
    }
}
</style>
